import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const insightsPortalAwarenessCampaignInsightsAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.InsightsPortalCampaign],
    featureToggles: FeatureToggle.InsightsPortalAwarenessCampaignsDashboard,
  },
  {
    permissions: [Permission.InsightsPortalCampaign],
    warehouseFeatureToggles: FeatureToggle.InsightsPortalAwarenessCampaignsDashboard,
  },
  {
    permissions: [Permission.InsightsPortalCampaign],
    minICPlatformVersion: ICPlatformVersion.r2025_01_0,
  },
]
